const companyDetailPlaceholderRegexString = "(?:___)|(?:\\[.{0,10}\\])";

export default companyDetailPlaceholderRegexString;
